/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "./config";

export default function EmployeeAttendanceRecords() {
  const [records, setRecords]     = useState([]);
  const [search, setSearch]       = useState("");
  const [statusFilter, setStatus] = useState("");
  const [startDate, setStart]     = useState("");
  const [endDate, setEnd]         = useState("");
  const [loading, setLoading]     = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API_BASE_URL}/attendance/all`)
      .then(res => setRecords(res.data || []))
      .catch(e => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  const getAttendanceStatus = (status) => {
    if (status === "Approved") return "Present";
    if (status === "Rejected") return "Absent";
    return "Pending";
  };

  const parseDate = (str) => {
    if (!str) return null;
    const p = str.split(" ");
    if (p.length < 3) return null;
    const [d, mo, y] = p[0].split("/").map(Number);
    let [h, m, s] = p[1].split(":").map(Number);
    if (p[2]?.toLowerCase() === "pm" && h !== 12) h += 12;
    if (p[2]?.toLowerCase() === "am" && h === 12) h = 0;
    return new Date(y, mo - 1, d, h, m, s);
  };

  const filtered = records.filter(r => {
    const q = search.toLowerCase();
    const matchSearch = (r.driverName || "").toLowerCase().includes(q) ||
                        (r.driverId   || "").toLowerCase().includes(q) ||
                        (r.vehicleNumber || "").toLowerCase().includes(q);
    const attStatus = getAttendanceStatus(r.status);
    const matchStatus = !statusFilter || attStatus === statusFilter;
    const rDate = parseDate(r.startTime);
    const matchStart = !startDate || (rDate && rDate >= new Date(startDate));
    const matchEnd   = !endDate   || (rDate && rDate <= new Date(endDate + "T23:59:59"));
    return matchSearch && matchStatus && matchStart && matchEnd;
  });

  const downloadCSV = () => {
    const h = "Driver ID,Name,Vehicle,Start,Stop,Duration,Approval Status,Attendance\n";
    const rows = filtered.map(r =>
      `${r.driverId},${r.driverName},${r.vehicleNumber},${r.startTime},${r.stopTime},${r.duration},${r.status},${getAttendanceStatus(r.status)}`
    ).join("\n");
    const blob = new Blob([h + rows], { type: "text/csv" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob);
    a.download = `att_records_${startDate || "all"}_to_${endDate || "all"}.csv`; a.click();
  };

  const S = {
    container: { fontFamily: "Arial, sans-serif", marginLeft: "270px", marginRight: "10px", backgroundColor: "#fff", color: "#000", minHeight: "100%", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    toolbar:   { display: "flex", gap: 10, alignItems: "center", padding: "14px 16px", flexWrap: "wrap" },
    input:     { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13 },
    select:    { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13, background: "#fff" },
    btnYellow: { background: "#FFC107", color: "#000", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    table:     { width: "100%", borderCollapse: "collapse" },
    th:        { background: "#000", color: "#fff", padding: "14px 12px", textAlign: "center", fontSize: 13, fontWeight: "bold" },
    td:        { border: "1px solid #000", padding: "10px 12px", textAlign: "center", fontSize: 13, color: "#000" },
  };

  const badgeStyle = (att) => ({
    background: att === "Present" ? "#e6f9ee" : att === "Absent" ? "#fde8e8" : "#fff8e1",
    color:      att === "Present" ? "#27ae60" : att === "Absent" ? "#c0392b" : "#d68910",
    padding: "3px 10px", borderRadius: 10, fontSize: 11, fontWeight: "bold",
  });

  return (
    <div style={S.container}>
      <h2 className="sendo-heading">Attendance Records</h2>

      <div style={S.toolbar}>
        <input style={S.input} placeholder="Search name, ID, vehicle..." value={search} onChange={e => setSearch(e.target.value)} />
        <select style={S.select} value={statusFilter} onChange={e => setStatus(e.target.value)}>
          <option value="">All Attendance</option>
          <option>Present</option>
          <option>Absent</option>
          <option>Pending</option>
        </select>
        <input style={S.input} type="date" value={startDate} onChange={e => setStart(e.target.value)} />
        <input style={S.input} type="date" value={endDate}   onChange={e => setEnd(e.target.value)} />
        <button style={S.btnYellow} onClick={downloadCSV}>⬇ Download</button>
        <span style={{ marginLeft: "auto", fontSize: 13, color: "#555" }}>{filtered.length} records</span>
      </div>

      {loading ? (
        <p style={{ padding: 20 }}>Loading records...</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>#</th>
                <th style={S.th}>Driver ID</th>
                <th style={S.th}>Driver Name</th>
                <th style={S.th}>Vehicle No.</th>
                <th style={S.th}>Date</th>
                <th style={S.th}>Start Time</th>
                <th style={S.th}>Stop Time</th>
                <th style={S.th}>Duration</th>
                <th style={S.th}>Approval</th>
                <th style={S.th}>Attendance</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={10} style={{ ...S.td, color: "#888" }}>No records found</td></tr>
              ) : filtered.map((r, i) => {
                const att = getAttendanceStatus(r.status);
                const d = parseDate(r.startTime);
                return (
                  <tr key={r._id} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                    <td style={S.td}>{i + 1}</td>
                    <td style={S.td}>{r.driverId}</td>
                    <td style={S.td}>{r.driverName}</td>
                    <td style={S.td}>{r.vehicleNumber}</td>
                    <td style={S.td}>{d ? d.toLocaleDateString("en-GB") : "—"}</td>
                    <td style={S.td}>{r.startTime}</td>
                    <td style={S.td}>{r.stopTime}</td>
                    <td style={S.td}>{r.duration}</td>
                    <td style={S.td}><span style={badgeStyle(att)}>{r.status}</span></td>
                    <td style={S.td}><span style={badgeStyle(att)}>{att}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
